import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const { ui } = constants.colors;
const { fontFamily, heading1Obj, textMObj } = typographyStyles;

export const headerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  paddingTop: "1em",
  backgroundColor: ui.white[100],
};
export const titleCss: CSSObject = {
  ...heading1Obj,
  ...fontFamily.noto,
  margin: "0.4em 0",
  fontWeight: 700,
};

export const metadataContainerCss: CSSObject = {
  width: "100%",
  marginBottom: "1em",
};

export const metadataCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  width: "100%",
  marginBottom: "0.5em",
  paddingBottom: "0.5em",
  borderBottom: `1px solid ${ui.neutral[100]}`,
};

export const metadataItemCss: CSSObject = {
  width: "fit-content",

  "&:not(:last-child)": {
    marginRight: "1em",
    paddingRight: "1em",
    borderRight: `1px solid ${ui.neutral[100]}`,
  },
};

export const labelCss: CSSObject = {
  marginRight: "0.5em",
  fontSize: "0.625rem",
  textTransform: "uppercase",
  color: ui.neutral[400],
  letterSpacing: "1px",
};

export const valueCss: CSSObject = {
  ...textMObj,
  color: ui.neutral[600],
};
